/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { UnitAcquisitionSortFieldName } from '../../models/unit-acquisition-sort-field-name';
import { UnitAcquisitionStatePagedList } from '../../models/unit-acquisition-state-paged-list';

export interface SearchUnitsAcquisitionParameters$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;
  sortFieldName?: UnitAcquisitionSortFieldName;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search units acquisition parameters
     */
    body?: any
}

export function searchUnitsAcquisitionParameters$Any(http: HttpClient, rootUrl: string, params?: SearchUnitsAcquisitionParameters$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitAcquisitionStatePagedList>> {
  const rb = new RequestBuilder(rootUrl, searchUnitsAcquisitionParameters$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnitAcquisitionStatePagedList>;
    })
  );
}

searchUnitsAcquisitionParameters$Any.PATH = '/units/acquisition-parameters/search';
